export default __webpack_public_path__ + "images/XZ.5eadccf.png";